import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatAutocomplete, MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {TaskService} from '@components/my-web-desk/new-task-modal/task.service';
import {MatChipList} from '@angular/material/chips';
import {ConstantsService} from '@app/services/constants/constants.service';
import {Globals} from "@app/services/globals.service";
import {ProventumApiService} from "@app/services/proventum-api.service";

@Component({
    selector: 'app-choose-validators',
    templateUrl: './choose-validators.component.html',
    styleUrls: ['./choose-validators.component.css']
})
export class ChooseValidatorsComponent implements OnInit {
    @Input() myForm: FormGroup;
    @Input() ids: number[];

    @Output() outputToParent = new EventEmitter<number[]>();

    @ViewChild('tagInput') tagInput: ElementRef<HTMLInputElement>;
    @ViewChild('auto') matAutocomplete: MatAutocomplete;
    @ViewChild('chipList') chipList: MatChipList;

    constructor(public proventumApiService: ProventumApiService,
                public taskService: TaskService,
                private fb: FormBuilder,
                private contantsService: ConstantsService,
                private globalsService: Globals) {
    }


    selectable = true;
    removable = true;

    separatorKeysCodes: number[] = [ENTER, COMMA];
    users = [];
    validatorTags = [];

    searchText = '';
    search = new FormControl();


    ngOnInit(): void {
        this.users = this.globalsService.getAllActiveUsers().map(value => {
            const item = {
                id: value.id,
                full_name: value['first_name'] + ' ' + value['last_name'],
                avatar: value.avatar
            };
            return item;
        });

        if (this.ids.length > 0) {
            this.ids.forEach(item => {
                let data = this.users.find(x => x.id === item);
                if (data) {
                    this.validatorTags.push(data);
                }
            });
            const ids = this.validatorTags.map(item => item.id);
            this.myForm.patchValue({validators: ids});
        }


    }

    remove(tag): void {
        this.validatorTags = this.validatorTags.filter(item => item.id !== tag.id);
        let ids = this.validatorTags.map(item => {
            return item.id
        });
        this.outputToParent.emit(ids);

    }


    selected(event: MatAutocompleteSelectedEvent): void {
        this.validatorTags.push(event.option.value);
        let ids = this.validatorTags.map(item => {
            return item.id
        });
        this.outputToParent.emit(ids);
        this.searchText = '';
        this.tagInput.nativeElement.value = '';
    }


}

